import { useState, useEffect } from "react"
import { Container } from "react-bootstrap"
import { DISPLAY_STATE } from "../constants"
import ActivityLockView from "./ActivityLockView"
import ActivityCloseModal from "./ActivityCloseModal"
import ActivityQuestionView from "./ActivityQuestionView"
import ActivityOpenDetailView from "./ActivityOpenDetailView"
import { useStudentActivityAccessQuery } from "@generated/graphql"

interface IActivity {
  slug: string
}

export default function ActivityDetail({ slug }: IActivity) {
  const [displayState, setDisplayState] = useState<DISPLAY_STATE>(DISPLAY_STATE.LOCK)
  const [showConfirmModal, setShowConfirmModal] = useState(false)

  const { data: userActivityAccessData, loading: userActivityAccessLoading, error: userActivityAccessError, refetch: userActivityAccessRefetch } = useStudentActivityAccessQuery({
    variables: { slug: slug },
    fetchPolicy: "cache-and-network"
  })

  useEffect(() => {
    if (userActivityAccessData) {
      if (userActivityAccessData.studentActivityAccess?.isUnlocked) {
        if (userActivityAccessData.studentActivityAccess?.isQaCompleted) {
          setDisplayState(DISPLAY_STATE.FULL)
        } else {
          setDisplayState(DISPLAY_STATE.UNLOCK)
        }
      }
    }
  }, [userActivityAccessData])

  return (
    <Container fluid className="h-100">
      {(displayState === DISPLAY_STATE.LOCK || displayState === DISPLAY_STATE.UNLOCK) && <ActivityLockView slug={slug} displayState={displayState} setDisplayState={setDisplayState} />}
      {displayState === DISPLAY_STATE.QA && <ActivityQuestionView slug={slug} displayState={displayState} setDisplayState={setDisplayState} setShowConfirmModal={setShowConfirmModal} />}
      {displayState === DISPLAY_STATE.FULL && <ActivityOpenDetailView slug={slug} />}
      {showConfirmModal && <ActivityCloseModal userActivityAccessRefetch={userActivityAccessRefetch} setDisplayState={setDisplayState} showConfirmModal={showConfirmModal} setShowConfirmModal={setShowConfirmModal} />}
    </Container>
  )
}
